'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUITE_STARTER = exports.SUITE_STARTER = 'growthstarter';
var SUITE_PROFESSIONAL = exports.SUITE_PROFESSIONAL = 'growthprofessional';
var SUITE_ENTERPRISE = exports.SUITE_ENTERPRISE = 'growthenterprise';
var BUNDLE = exports.BUNDLE = 'bundle';


//////////////////
// WEBPACK FOOTER
// ./js/constants/NonMerchandiseIdProducts.js
// module id = 316
// module chunks = 3 4 5